import { html } from "lit-html";

export const criteriaTemplate = criteria =>
	html`<span class="hotel-list-item__criteria">
		${criteria.map(
			criterion =>
				html`<span class="hotel-list-item__criterion">${criterion}</span>`,
		)}</span
	>`;
